import {
  AccessDeniedError,
  BadRequestError,
  ConnectionError,
  HttpTypes,
  InternalServerError,
  TooManyRequestsError,
  UnexpectedError,
} from 'src/http';
import { httpResponseHandler } from 'src/http/http-response-handler';
import { fileUploadType } from 'src/types/banners';
import { PromotionManager } from 'src/types/promotions';
import { endpoints } from 'src/utils/axios';
import { Either } from 'src/utils/either';

export class PromotionsRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async getPromotionsList(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.promotions.promotionsList,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getPromotionDetails(
    id: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.promotions.promotionDetails(id),
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async createPromotion(
    promotion: PromotionManager
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.benefits.promotions.createPromotion,
      body: promotion,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async updatePromotion(
    id: string,
    promotion: PromotionManager
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: endpoints.benefits.promotions.updatePromotion(id),
      body: promotion,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async uploadFile(
    file: fileUploadType
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.files.upload,
      body: { ...file, optimizateImage: true },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
